module.exports = __webpack_public_path__ + "img/exclamationmark-triangle.ad38c224.svg";